module.exports = __webpack_public_path__ + "models/scene4.80435c7.txt";